import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";

/**
 * Select riusabile "Assegna a {agente}" con indicatore di presenza online.
 * Visibile solo agli admin. Per gli altri utenti ritorna null (l'agent_id viene
 * impostato server-side al creatore).
 *
 * Props:
 * - value: agent_id corrente (string | undefined)
 * - onChange: (agent_id) => void
 * - label: label opzionale (default "Assegna a")
 * - testId: data-testid override
 */
export function AssignToSelect({ value, onChange, label = "Assegna a", testId = "assign-to-select" }) {
  const { user } = useAuth();
  const [staff, setStaff] = useState([]);

  useEffect(() => {
    if (user?.role !== "admin") return;
    api.get("/agency/staff-presence")
      .then(({ data }) => setStaff(data || []))
      .catch(() => {});
  }, [user]);

  if (user?.role !== "admin") return null;

  const fmtPresence = (lastSeenAt) => {
    if (!lastSeenAt) return { dot: "⚪", label: "" };
    const diffMin = (Date.now() - new Date(lastSeenAt).getTime()) / 60000;
    if (diffMin <= 5) return { dot: "🟢", label: "online" };
    if (diffMin <= 30) return { dot: "🟡", label: `${Math.round(diffMin)}min fa` };
    if (diffMin <= 60 * 24) return { dot: "⚫", label: `${Math.round(diffMin / 60)}h fa` };
    return { dot: "⚪", label: `${Math.round(diffMin / (60 * 24))}gg fa` };
  };

  return (
    <div>
      <label className="text-xs font-medium block mb-1 text-slate-700">{label}</label>
      <select
        data-testid={testId}
        className="w-full h-10 rounded-md border border-slate-300 px-3 text-sm bg-white"
        value={value || user.id}
        onChange={(e) => onChange(e.target.value)}
      >
        <option value={user.id}>👤 Me stesso ({user.name || user.email})</option>
        {staff.filter((s) => s.id !== user.id).map((s) => {
          const p = fmtPresence(s.last_seen_at);
          return (
            <option key={s.id} value={s.id}>
              {p.dot} {s.name || s.email} {p.label ? `· ${p.label}` : ""} · {s.role}
            </option>
          );
        })}
      </select>
    </div>
  );
}
